/**
 * Copy for premium savings footer animation (renewal preview).
 * Kept out of widget files so content can be reviewed / swapped without touching UI logic.
 */

/** Slide phase: full heading HTML; {{amount}} = formatted INR digits only (no ₹) */
export const GOOD_NEWS_SLIDE_HEADING_HTML_TEMPLATE =
  'Good news! You <span class="discount-green">save ₹{{amount}}</span> this year';

export function buildGoodNewsSlideHeading(formattedInrAmount: string): string {
  return GOOD_NEWS_SLIDE_HEADING_HTML_TEMPLATE.replace(
    /\{\{amount\}\}/g,
    formattedInrAmount
  );
}

/** Counter phase: amount is rendered between prefix and suffix (may include ₹ + animated digits) */
export const GOOD_NEWS_COUNTER_PHRASE = {
  prefix: "Good news! You save ",
  suffix: " this year"
} as const;
